import axios from "axios";
import { Token } from "../utils/localStorage.util";
import config from "../config.js";

const apiContratos = axios.create({
  baseURL: config.REACT_APP_HOST_API_CONTRATOS,
});

apiContratos.interceptors.request.use(
  async (config) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiContratos.interceptors.response.use(
  (response) => {
    return response.data;
  },

  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error("Erro de conexão (ERR_NETWORK):", error);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export function criarContrato(body) {
  return apiContratos.post(`/contratos`, body);
}

export function trazContrato(dadosUsuario) {
  //essa função não traz o id do contrato :c
  return apiContratos.get(`/contratos/${dadosUsuario.id}/${dadosUsuario.tipo}`);
}

export function alteraContrato(body) {
  return apiContratos.put(`/contratos/altera-contrato`, body);
}

export function buscaTodosContratos(textoBusca) {
  return apiContratos.get(`/contratos${textoBusca ? `?textoBusca=${textoBusca}` : ""}`);
}

export function cancelaContrato(idContrato) {
  return apiContratos.patch(`/contratos/cancel-contrato/${idContrato}`);
}

export function alteraDataExpiracao(idContrato, body) {
  return apiContratos.post(`/contratos/nova-data-exp/${idContrato}`, body);
}

export function buscaSignatarios(idContrato) {
  return apiContratos.get(`/contratos/busca-signatarios/${idContrato}`);
}

export function buscaTodosSignatario() {
  return apiContratos.get(`/contratos/busca-todos-signatarios`);
}

export function alteraSignatarios(idContrato, body) {
  return apiContratos.post(`/contratos/altera-signatarios/${idContrato}`, body);
}

export function buscaTodosNotSign() {
  return apiContratos.get(`/contratos/busca-users-notSign/`);
}

export default apiContratos;
